import type {
  AppointmentHistoryEntry,
  BuildJsonType,
} from '@bb/domain/dist/types';

const apptHistoryUserName = ({
  isAssumedNotBB,
  orgType,
  userName,
}: AppointmentHistoryEntry | BuildJsonType<AppointmentHistoryEntry>) => {
  if (!userName) return '';

  let prefix = '';
  if (isAssumedNotBB || orgType === 'answering') {
    prefix = 'ANSWERING SERVICE - ';
  } else if (orgType === 'mlsStaff') {
    prefix = 'MLS STAFF - ';
  }
  return `${prefix}${userName}`;
};

export default apptHistoryUserName;
